import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { label: "Home", path: "/" },
  { label: "Calculators", path: "/calculators" },
  { label: "States", path: "/states" },
  { label: "Blog", path: "/blog" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-40 border-b-2 border-foreground bg-background"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <div className="w-9 h-9 bg-primary text-primary-foreground flex items-center justify-center font-heading font-bold text-xl group-hover:-rotate-6 transition-transform">
              T
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-heading font-bold text-xl tracking-tight">TaxShift</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                2026 · OBBBA EDITION
              </span>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8" data-testid="nav-desktop">
            {NAV_ITEMS.map((item) => {
              const active = location.pathname === item.path || location.pathname.startsWith(item.path + "/");
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-link-${item.label.toLowerCase()}`}
                  className={`font-mono uppercase text-xs tracking-widest transition-colors ${
                    active ? "text-primary" : "text-foreground hover:text-primary"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/calculators"
              data-testid="nav-cta-calculate"
              className="font-mono uppercase text-xs tracking-widest bg-foreground text-background px-5 py-2.5 hover:bg-primary transition-colors"
            >
              Calculate 2026 →
            </Link>
          </nav>

          {/* Mobile menu toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 border border-foreground"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <nav
            className="md:hidden border-t border-foreground/20 py-4 flex flex-col gap-3"
            data-testid="nav-mobile"
          >
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className="font-mono uppercase text-sm tracking-widest py-2"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/calculators"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="font-mono uppercase text-sm tracking-widest bg-foreground text-background px-5 py-3 mt-2 text-center"
            >
              Calculate 2026 →
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};
